<template>
  <div class="recordDetail">
    <div class="recordDetail_pic">
      <!-- <img
        class="recordDetail_return"
        src="../../assets/img/welfare/nav_return@2x.png"
        alt=""
        style="width: 0.1rem; height: 0.17rem"
        @click="goBack()"
      /> -->
      <img
        :src="recordDetailMessage.pic"
        alt=""
        style="width: 2.44rem; height: 2.43rem"
      />
    </div>
    <div class="recordDetail_title">
      <p
        style="
          font-size: 0.16rem;
          color: #ffffff;
          line-height: 0.2rem;
          margin-bottom: 0.03rem;
        "
      >
        {{ recordDetailMessage.title ? recordDetailMessage.title : "--" }}
      </p>
      <p
        style="
          font-size: 0.12rem;
          color: #ffffff;
          opacity: 0.6;
          margin-bottom: 0.04rem;
          display: flex;
          justify-content: space-between;
        "
      >
        <span
          >已兑换{{
            recordDetailMessage.buys ? recordDetailMessage.buys : "-"
          }}件</span
        >
        <span
          >库存：{{
            recordDetailMessage.num == -1 ? "充足" : recordDetailMessage.num
          }}</span
        >
      </p>
      <div class="recordDetail_title_cord">
        <p style="font-size: 0.19rem; color: #f12727">
          {{ recordDetailMessage.price }}
          <span style="font-size: 0.14rem">积分</span>
        </p>
        <!-- 收藏 -->
        <img
          @click="iLikeThis(recordDetailMessage.id, 2)"
          :src="
            recordDetailMessage.like == 1
              ? require('../../assets/img/tabbar_img/tab_icon_collection_red@2x.png')
              : require('../../assets/img/tabbar_img/tab_icon_collection@2x.png')
          "
          alt=""
          style="width: 0.22rem; height: 0.19rem"
        />
      </div>
    </div>
    <div class="recordDetail_detail">
      <h2 style="font-size: 0.16rem; color: #333333">商品详情</h2>
      <!-- <img :src="recordDetailMessage.content_url" alt="" style="width: 100%; height: 1.94rem" /> -->
      <!-- <iframe
        :src="recordDetailMessage.content_url"
        frameborder="0"
        style="width: 100%; height: 1.94rem"
        scrolling="no"
      ></iframe> -->
      <div v-html="recordDetailMessage.content" style="width：100%"></div>
    </div>
    <div class="recordDetail_tabbar">
      <!-- 加减按钮 -->
      <div class="addSubtract">
        <!-- 加减按钮 -->
        <div class="addSubtract_btn" style="width: 1.41rem; height: 0.38rem">
          <!-- - -->
          <van-button
            :icon="
              this.num == 1
                ? require('../../assets/img/icon_reduce_gray@2x.png')
                : require('../../assets/img/icon_reduce_black@2x.png')
            "
            type="info"
            color="white"
            class="reduce"
            @click="numReduce()"
          >
          </van-button>
          <input type="text" class="number" v-model="num" />
          <van-button
            :icon="
              recordDetailMessage.num == -1
                ? require('../../assets/img/icon_plus_black.png')
                : require('../../assets/img/icon_plus_gray.png')
            "
            type="info"
            color="white"
            class="plus"
            @click="numPluse(recordDetailMessage.num)"
          >
          </van-button>
        </div>
      </div>
      <van-button class="recordNow" plain type="defult" @click="toRecord()"
        >立即兑换</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getRecordDetailList, setCollectionState } from '../../api/home'
export default {
  data () {
    return {
      num: 1,
      recordDetailMessage: {},
      score_id: ''
    }
  },
  methods: {
    // 确认订单
    toRecord () {
      this.$router.push({
        name: '确认订单',
        params: {
          commodityDetail: {
            id: this.recordDetailMessage.id,
            title: this.recordDetailMessage.title,
            user_price: this.recordDetailMessage.price,
            pic: this.recordDetailMessage.pic
          },
          number: this.num,
          flag: true
        }
      })
    },
    // 点击数量增加
    numPluse (val) {
      this.num++
      if (val != -1 && this.num == val + 1) {
        Toast('库存不足！')
        this.num = val
      }
    },
    // 点击数量减少
    numReduce () {
      this.num--
      if (this.num < 1) {
        Toast('至少购买一件哦')
        this.num = 1
      }
    },
    // 是否收藏
    iLikeThis (id, type) {
      setCollectionState({ shop_id: id, type: type }).then((res) => {
        Toast(res.data.msg)
        if (this.recordDetailMessage.like === 0) {
          this.recordDetailMessage.like = 1
        } else {
          this.recordDetailMessage.like = 0
        }
      })
    }
  },

  activated () {
    if (this.$route.params.score_id) {
      sessionStorage.setItem('score_id', this.$route.params.score_id)
      this.score_id = this.$route.params.score_id
    } else {
      this.score_id = sessionStorage.getItem('score_id')
    }
    getRecordDetailList({ score_id: this.score_id })
      .then((res) => {
        this.recordDetailMessage = res.data.backdata
        this.num = 1
      })
      .catch((err) => {
        console.log(err)
      })
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background:#ffffff')
  },
  beforeDestroy () {
    document.querySelector('body').setAttribute('style', 'background:#f3f1f4')
  }
}
</script>

<style lang='scss'>
.recordDetail {
  padding-bottom: 0.65rem;
  background: #ffffff;
  .recordDetail_pic {
    width: 100%;
    height: 2.88rem;
    background: #fcf9fc;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.46rem;
    .recordDetail_return {
      margin-top: 0.02rem;
      margin-right: 0.41rem;
    }
  }
  .recordDetail_title {
    width: 100%;
    height: 1.19rem;
    background: #d1ad79;
    padding: 0.12rem 0.15rem 0.1rem 0.15rem;
    .recordDetail_title_cord {
      width: 100%;
      height: 0.54rem;
      background: #ffffff;
      padding: 0 0.21rem 0 0.22rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .recordDetail_detail {
    padding: 0 0.15rem 0.24rem 0.15rem;
    h2 {
      height: 0.58rem;
      line-height: 0.58rem;
    }
    img {
      width: 3.45rem;
    }
  }

  .recordDetail_tabbar {
    width: 100%;
    height: 0.65rem;
    background: #ffffff;
    box-shadow: 0 0 0.05rem 0 rgba(0, 0, 0, 0.08);
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    padding: 0 0.15rem;
    align-items: center;
    .addSubtract_btn {
      width: 1.4rem;
      height: 0.38rem;
      background: url("../../assets/img/icon_frame_number@2x.png") no-repeat;
      background-size: 1.41rem 0.38rem;
      display: flex;
      align-items: center;
      padding: 0 0.01rem;
      .van-button {
        width: 0.36rem;
        height: 0.36rem;
        padding: 0rem;
        border: none;
        .van-button__icon {
          width: 0.14rem;
          height: 0.15rem;
          .van-icon__image {
            width: 0.14rem;
            height: 0.14rem;
          }
        }
      }
      .plus {
        width: 0.37rem;
      }
      .number {
        width: 0.66rem;
        text-align: center;
        margin: 0 0.02rem;
        border: none;
        font-size: 0.14rem;
      }
    }
    .recordNow {
      width: 1.78rem;
      height: 0.44rem;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      box-shadow: 0 0.05rem 0.1rem 0 rgba(0, 83, 16, 0.04);
      border-radius: 0.02rem;
      border: none;

      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
      line-height: 0.2rem;
    }
  }
}
</style>
